import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["aria-labelledby"]
const _hoisted_2 = { class: "nr-datepicker-calendar-header" }
const _hoisted_3 = ["id"]
const _hoisted_4 = ["aria-labelledby"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "has-text-centered",
      scope: "col",
      abbr: "Sunday"
    }, "Su"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "has-text-centered",
      scope: "col",
      abbr: "Monday"
    }, "Mo"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "has-text-centered",
      scope: "col",
      abbr: "Tuesday"
    }, "Tu"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "has-text-centered",
      scope: "col",
      abbr: "Wednesday"
    }, "We"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "has-text-centered",
      scope: "col",
      abbr: "Thursday"
    }, "Th"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "has-text-centered",
      scope: "col",
      abbr: "Friday"
    }, "Fr"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "has-text-centered",
      scope: "col",
      abbr: "Saturday"
    }, "Sa")
  ])
], -1)
const _hoisted_6 = { class: "nr-datepicker-calendar-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NrIconButton = _resolveComponent("NrIconButton")!
  const _component_NrDatepickerDay = _resolveComponent("NrDatepickerDay")!
  const _component_NrButton = _resolveComponent("NrButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: "nr-datepicker-calendar",
    onKeydown: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleGlobalKeypress && _ctx.handleGlobalKeypress(...args))),
    role: "dialog",
    "aria-modal": "true",
    "aria-labelledby": `${_ctx.id}-header__label`
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_NrIconButton, {
        "aria-label": "Previous year",
        variant: "minimal-neutral",
        icon: { name: 'chevron-double-left', type: 'regular' },
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleYearButton($event, -1))),
        onKeydown: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleYearButton($event, -1))),
        ref: "previousYearBtn"
      }, null, 512),
      _createVNode(_component_NrIconButton, {
        variant: "minimal-neutral",
        icon: { name: 'chevron-left', type: 'regular' },
        "aria-label": "Previous month",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleMonthButton($event, -1))),
        onKeydown: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleMonthButton($event, -1)))
      }),
      _createElementVNode("h2", {
        id: `${_ctx.id}-header__label`,
        class: "nr-datepicker-calendar-header__label",
        "aria-live": "polite"
      }, _toDisplayString(_ctx.month) + " " + _toDisplayString(_ctx.year), 9, _hoisted_3),
      _createVNode(_component_NrIconButton, {
        variant: "minimal-neutral",
        icon: { name: 'chevron-right', type: 'regular' },
        "aria-label": "Next month",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleMonthButton($event, 1))),
        onKeydown: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleMonthButton($event, 1)))
      }),
      _createVNode(_component_NrIconButton, {
        variant: "minimal-neutral",
        icon: { name: 'chevron-double-right', type: 'regular' },
        "aria-label": "Next year",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleYearButton($event, 1))),
        onKeydown: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleYearButton($event, 1))),
        ref: "nextYearBtn"
      }, null, 512)
    ]),
    _createElementVNode("table", {
      class: "nr-datepicker-calendar-dates table is-narrow",
      role: "grid",
      "aria-labelledby": `${_ctx.id}-header__label`
    }, [
      _hoisted_5,
      _createElementVNode("tbody", {
        onKeydown: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleDateNavigation && _ctx.handleDateNavigation(...args)))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getDates, (week, weekIndex) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: `week-${weekIndex + 1}`
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(week, (day, dayIndex) => {
              return (_openBlock(), _createElementBlock("td", {
                key: `day ${dayIndex + 1} of week ${weekIndex}`,
                class: "has-text-centered"
              }, [
                _createVNode(_component_NrDatepickerDay, {
                  day: day,
                  disabled: _ctx.isDisabled(day),
                  selected: _ctx.isSelectedDate(day),
                  focus: _ctx.isFocusDate(day),
                  onClick: ($event: any) => (_ctx.handleDateClick($event, day)),
                  ref_for: true,
                  ref: "datesEl"
                }, null, 8, ["day", "disabled", "selected", "focus", "onClick"])
              ]))
            }), 128))
          ]))
        }), 128))
      ], 32)
    ], 8, _hoisted_4),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_NrButton, {
        variant: "bordered-primary",
        ref: "cancelBtn",
        onClick: _ctx.handleCancelButton,
        onKeydown: _ctx.handleCancelButton
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Cancel ")
        ]),
        _: 1
      }, 8, ["onClick", "onKeydown"]),
      _createVNode(_component_NrButton, {
        ref: "selectBtn",
        onClick: _ctx.handleSelectButton,
        onKeydown: _ctx.handleSelectButton
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Select date ")
        ]),
        _: 1
      }, 8, ["onClick", "onKeydown"])
    ])
  ], 40, _hoisted_1))
}